import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/email-illustration.svg";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(SectionHeading)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`

const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col max-w-sm mx-auto md:mx-0`
const Input = tw.input`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`
const Textarea = styled(Input).attrs({ as: "textarea" })`
  ${tw`h-24`}
`

const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8`

export default ({
  subheading = "Contact Us",
  heading = <>Contactează-ne <span tw="text-primary-500">oricând!</span><wbr /></>,
  description = "Dorim să îmbunătățim constant platformele Busify, așa că dorim să știm dacă ne-au scăpat anumite detalii, putem adăuga ceva în plus, sau chiar să colaborăm împreună cu întreprinderea ta!",
  submitButtonText = "Send",
  formAction = "#",
  formMethod = "get",
  textOnLeft = true,
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.

  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
          <Image imageSrc={EmailIllustrationSrc} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            {description && <Description>{description}</Description>}

            <form
              method='POST'
              name='contactform'
              className='contactForm'
              netlify-honeypot="bot-field"
              data-netlify="true"
              data-netlify-recaptcha="true"
              style={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <p class="hidden">
                <label>
                  Don’t fill this out if you’re human: <input name="bot-field" />
                </label>
              </p>
              <input
                type='hidden'
                name='form-name'
                value='contactForm' />

              <input
                type='text'
                name='name'
                placeholder='Numele tău'
                style={{
                  margin: '20px 20px 20px 0px',
                  padding: '5px 10px 5px 10px',
                  borderRadius: '5px',
                  border: '2px solid gray'
                }} />

              <input
                type='email'
                name='email'
                placeholder='Email'
                style={{
                  margin: '20px 20px 20px 0px',
                  padding: '5px 10px 5px 10px',
                  borderRadius: '5px',
                  border: '2px solid gray'
                }} />

              <textarea
                name='message'
                placeholder='Mesaj'
                style={{
                  margin: '20px 20px 20px 0px',
                  padding: '5px 10px 5px 10px',
                  borderRadius: '5px',
                  border: '2px solid gray'
                }}></textarea>

              <div data-netlify-recaptcha="true"></div>

              <button type='submit' style={{
                padding: '5px 10px 5px 10px',
                margin: '0px 20px 20px 0px',
                color: 'white',
                background: 'purple',
                borderRadius: '5px'
              }}>Trimite</button>
            </form>

          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
